import React, { useEffect } from 'react'

export default function LightboxModal({ images, activeIndex, onClose, onIndexChange }) {
  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowRight' && activeIndex < images.length - 1) {
        onIndexChange(activeIndex + 1)
      }
      if (e.key === 'ArrowLeft' && activeIndex > 0) {
        onIndexChange(activeIndex - 1)
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    document.body.style.overflow = 'hidden'
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = ''
    }
  }, [activeIndex, images.length, onClose, onIndexChange])

  if (!images || images.length === 0 || activeIndex === null) return null

  const currentImage = images[activeIndex]

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/90 backdrop-blur-sm p-4 select-none animate-in fade-in duration-200"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Billedvisning i fuld størrelse"
    >
      {/* Close button */}
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 z-10 p-3 text-white/80 hover:text-white text-2xl transition-colors focus:outline-none drop-shadow-md"
        aria-label="Luk visning"
      >
        <i className="fa-solid fa-xmark" aria-hidden="true" />
      </button>

      {/* Prev button */}
      {images.length > 1 && activeIndex > 0 && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onIndexChange(activeIndex - 1)
          }}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-10 p-3 text-white/80 hover:text-white text-3xl transition-colors focus:outline-none drop-shadow-md"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left" aria-hidden="true" />
        </button>
      )}

      {/* Next button */}
      {images.length > 1 && activeIndex < images.length - 1 && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onIndexChange(activeIndex + 1)
          }}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-10 p-3 text-white/80 hover:text-white text-3xl transition-colors focus:outline-none drop-shadow-md"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right" aria-hidden="true" />
        </button>
      )}

      {/* Image container */}
      <div
        className="relative max-w-5xl max-h-[85vh] flex items-center justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={currentImage}
          alt={`Billede ${activeIndex + 1} af ${images.length}`}
          className="max-w-full max-h-[85vh] object-contain rounded-none shadow-2xl"
        />

        {/* Counter */}
        {images.length > 1 && (
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 bg-slate-900/80 text-white text-xs font-mono px-3 py-1 rounded-full backdrop-blur-xs">
            {activeIndex + 1} / {images.length}
          </div>
        )}
      </div>
    </div>
  )
}
